import { EMPTY_STRING } from "./shared.constants";

export const eventBookingConstants = {
  GET_AVAILABLE_SHUTTERB: "GET_AVAILABLE_SHUTTERB",
  CHECK_OUT: "CHECK_OUT",
  SET_CART_TAB: "SET_CART_TAB",
  GET_SHOT_LIST: "GET_SHOT_LIST",
  SET_FORM_STATE: "SET_FORM_STATE",
  SET_EDIT_EVENTS: "SET_EDIT_EVENTS",
  SET_DRAFT_EVENTS: "SET_DRAFT_EVENTS",
  EVENT_ALREADY_EXIST: "EVENT_ALREADY_EXIST",
  IS_SB_TIP_EXTEND_CART: "IS_SB_TIP_EXTEND_CART",
  USE_SAME_LOGO_FOR_ALL_RECAPS: "USE_SAME_LOGO_FOR_ALL_RECAPS",
  REQUEST_BOOKING: "REQUEST_BOOKING",
  GET_EVENT_TYPES: "GET_EVENT_TYPES",
  GET_EDIT_BRIEF: "GET_EDIT_BRIEF",
  ADD_RECAPZ: "ADD_RECAPZ",
  ADD_RECAPZ_BACKUP: "ADD_RECAPZ_BACKUP",
  SELECTED_SHUTTER_BS: "SELECTED_SHUTTER_BS",
  SET_IS_PROFILE_VIEW: "SET_IS_PROFILE_VIEW",
  SELECTED_EVENT_ID: "SELECTED_EVENT_ID",
  CURRENT_EVENT_TYPE: "CURRENT_EVENT_TYPE",
  EVENT_NAME: "EVENT_NAME",
  GET_AVAILABLE_SHUTTER_BS: "GET_AVAILABLE_SHUTTER_BS",
  GET_EVENT_TYPE_SHOT_LIST: "GET_EVENT_TYPE_SHOT_LIST",
  TOTAL_EVENTS: "TOTAL_EVENTS",
  LAST_ACTIVE_TAB: "LAST_ACTIVE_TAB",
  IS_EDIT_EVENT: "IS_EDIT_EVENT",
  IS_DRAFT_EVENT: "IS_DRAFT_EVENT",
  GET_REEL_PRICE: "GET_REEL_PRICE",
  SET_REEL_VALUES: "SET_REEL_VALUES",
  SET_REEL_VALUES_ON_DELETE: "SET_REEL_VALUES_ON_DELETE",
  GET_MISC_AMOUNTS: "GET_MISC_AMOUNTS",
  GET_MISC_AMOUNTS_OLD: "GET_MISC_AMOUNTS_OLD",
  GET_EDIT_EVENT: "GET_EDIT_EVENT",
  GET_DRAFT_EVENT: "GET_DRAFT_EVENT",
  GET_RECAP_TYPES: "GET_RECAP_TYPES",
  REEL_STORED: "REEL_STORED",
  SET_UNDO_CART_ITEM: "SET_UNDO_CART_ITEM",
  UPLOAD_MUSIC_FILE: "UPLOAD_MUSIC_FILE",
  ASSIGN_SHUTTERB: "ASSIGN_SHUTTERB",
  NOTIFY_ADMIN_TO_ASSIGN_SHUTTERB: "NOTIFY_ADMIN_TO_ASSIGN_SHUTTERB",
  TABS: {
    EVENT_SETUP: 1,
    EVENT_DETAIL: 2,
    SELECT_SHUTTERB: 3,
    ADD_REEL: 4,
    CART: 5,
  },
  // add reel
  REEL_QTY_OPTIONS: [0, 1, 2, 3, 4, 5],
  REEL_ORIENTATION_OPTIONS: [
    "Portrait (Instagram, TikTok)",
    "Landscape (YouTube)",
  ],
  ADD_REEL_STATES: {
    IS_REEL_WITHOUT_LOGO: "isReelWithoutLogo",
    REEL_PRICE_WITHOUT_LOGO: "reelPriceWithoutLogo",
    REEL_QTY_WITHOUT_LOGO: "reelQtyWithoutLogo",
    IS_REEL_WITH_LOGO: "isReelWithLogo",
    REEL_PRICE_WITH_LOGO: "reelPriceWithLogo",
    REEL_QTY_WITH_LOGO: "reelQtyWithLogo",
    LOGO: "logo",
    REEL_QUESTION_ONE: "reelQuestion1",
    MUSIC: "music",
    ORIENTATION: "orientation",
    TERMS: "terms",
    REEL_TOTAL: "reelTotal",
    IS_REEL_SUBMITTED: "isReelSubmitted",
    MUSIC_FILE: "musicFile",
    REEL_TYPE: "reelType",
  },
  ORDER_ITEM_TYPE_ID: {
    NEW_EVENT_SB: 2,
    REEL: 3,
  },
  ADD_EVENT_DETAIL: {
    EVENT_QUESTION_ONE: "eventQuestion1",
    EVENT_QUESTION_TWO: "eventQuestion2",
    EVENT_QUESTION_THREE: "eventQuestion3",
    EVENT_QUESTION_FOUR: "eventQuestion4",
  },
  TIP_PRICE_: "tipPrice_",
  EXTENDED_PRICE_: "extendedPrice_",
  SET_IS_DRAFT_EVENT_ALLOWED: "SET_IS_DRAFT_EVENT_ALLOWED",
  SET_BULK_REEL_VALUES: "SET_BULK_REEL_VALUES",
  SET_EVENT_DETAIL_VALUES: "SET_EVENT_DETAIL_VALUES",
  EVENT_DETAIL_STORED: "EVENT_DETAIL_STORED",
  GET_REEL_TYPES: "GET_REEL_TYPES",
  SET_BULK_EVENT_DETAIL_VALUES: "SET_BULK_EVENT_DETAIL_VALUES",
  DEFAULT_ACTIVE_TAB: 0,
  TABS_ID: {
    EVENT_SETUP: 0,
    SELECT_SHUTTERB: 1,
    EVENT_DETAIL: 2,
    ADD_REEL: 3,
    CART: 4,
    CHECK_OUT: 5,
  },
  REEL: {
    DEFAULT_QUANTITY: "1",
  },
  IS_NEW_BOOKING: {
    DRAFT: "0",
    NEW_EVENT: "1",
    ADD_SHUTTERB: "2",
  },
  CHECKOUT_STATUS: {
    EDIT_DRAFT_EVENT: "draft_checkout",
    TIP_OR_EXTEND: "tip_or_extend_checkout",
  },

  PARTNER_CODE: "partnerCode",
  AFFILIATE_CODE: "affiliateCode",
  REGENERATE_EDIT_BRIEF: "REGENERATE_EDIT_BRIEF",
};

export const fieldName = {
  DURATION: "duration",
  EVENT_DATE: "eventDate",
  APPARTMENT: "apartment",
  EVENT_LOCATION: "eventLocation",
  EVENT_START_TIME: "eventStartTime",
  SHUTTERB_START_TIME: "sbStartTime",
};

export const eventDetailsFields = {
  PHONE_NUMBER: "phoneNumber",
  EVENT_TYPE: "eventType",
  EVENT_QUESTION_ANSWERS: "eventQuestionAnswers",
  NAME: "name",
  DESCRIPTION: "description",
  CONTACT_NAME: "contactName",
  IS_OPTIONAL_DETAILS: "isOptionalDetails",
};

export const QUESTION_TYPE_IDS = {
  CONTENT_USAGE: 21,
  BRAND_GUIDELINES: 9,
  ADD_RECAP_PURPOSE: 6,
};

export const eventBookingStatus = {
  TIP: "tip",
  EDITED: "edited",
  CANCEL: "cancel",
  CREATED: "created",
  EXTENDED: "extended",
  NOTIFY_ADMIN: "notify_admin",
  TIP_OR_EXTEND: "tip_or_extended",
};

export const defaultEventSetupObject = {
  id: "1",
  eventName: EMPTY_STRING,
  eventDate: EMPTY_STRING,
  eventStartTime: EMPTY_STRING,
  eventLocation: {
    currentLocation: EMPTY_STRING,
    longitude: null,
    latitude: null,
    postalCode: EMPTY_STRING,
  },
  apartment: EMPTY_STRING,
  eventType: EMPTY_STRING,
  additionalNotes: EMPTY_STRING,
  notes: EMPTY_STRING,
  sbStartTime: EMPTY_STRING,
  duration: EMPTY_STRING,
  termsAndConditions: false,
  privacyPolicy: false,
  isGallerySharedPermission: true,
  isConsentForMarketing: true,
  contactName: EMPTY_STRING,
  phoneNumber: EMPTY_STRING,
  eventQuestionAnswers: [],
  status: eventBookingStatus.CREATED,
};

export const durationOptions = [
  { id: 1, label: "2h", value: 2 },
  { id: 2, label: "2h 30m", value: 2.5 },
  { id: 3, label: "3h", value: 3 },
  { id: 4, label: "3h 30m", value: 3.5 },
  { id: 5, label: "4h", value: 4 },
  { id: 6, label: "4h 30m", value: 4.5 },
  { id: 7, label: "5h", value: 5 },
];

export const ONE_THOUSAND = 1000;
export const ONE_HOUR_IN_MS = 60 * 60 * 1000;
export const TIME_MARGIN_IN_EVENT = 2;
export const DEFAULT_COUNTRY = "ca";

export const stepTitleKeys = [
  "book_your_event",
  "select_your_shutterb",
  "event_details",
  "add_recap",
  "cart_summary",
  "checkout",
];

export const TABS = {
  0: "event_setup",
  1: "shutterb_results",
  2: "event_detail",
  3: "add_recaps",
  4: "cart_summary",
  5: "checkout",
};

export const EVENT_BOOKING_TABS = {
  EVENT_SETUP: "event_setup",
  SHUTTERB_RESULTS: "shutterb_results",
  EVENT_DETAIL: "event_detail",
  ADD_RECAPS: "add_recaps",
  CART_SUMMARY: "cart_summary",
  CHECKOUT: "checkout",
};

export const tipYourShutterb = {
  ADD_TO_CART: "ADD_TO_CART",
  CHECKOUT: "CHECKOUT",
};

export const SHUTTERB_DETAILS_KEYS = {
  SHUTTERB: "SHUTTERB",
  DATE: "DATE",
  START_TIME: "START_TIME",
  DURATION: "DURATION",
  QUANTITY: "QUANTITY",
  RATE: "RATE",
  TIP: "TIP",
  TOTAL: "TOTAL",
  STATUS: "STATUS",
};

export const recapDetailsKeys = {
  TYPE: "TYPE",
  QUANTITY: "QUANTITY",
  RATE: "RATE",
  TOTAL: "TOTAL",
  STATUS: "STATUS",
};

export const EVENT_TYPE_ID = {
  DRAFT: 0,
  EVENT: 1,
};

export const DRAFT_EVENT = {
  DISCARD: 0,
  DRAFT: 1,
};

export const eventBookingParams = {
  DRAFT_EVENT: "5",
  EDIT_EVENT: "6",
};
